// extracted by mini-css-extract-plugin
export default {"screen":"Audio_screen__fJLhE","logo":"Audio_logo__oixot","body":"Audio_body__jgcbB","headerBox":"Audio_headerBox__zD5Ys"};